import AppLayout from '../layout/AppLayout';
import About from '../pages/profile/about';
import Bookmarks from '../pages/profile/bookmarks';
import EditProfile from '../pages/profile/edit';
import Faq from '../pages/profile/faq';
import Profile from '../pages/profile/home';
import Law from '../pages/profile/law';
import MyAds from '../pages/profile/my-ads';
import MyAdDetails from '../pages/profile/my-ads/ad-details';
import Support from '../pages/profile/support';
import {AppRouteConfig} from './route.types';

export const profileRoutes: AppRouteConfig[] = [
  {
    path: 'profile',
    element: AppLayout,
    children: [
      {index: true, element: Profile},
      {path: 'about', element: About},
      {path: 'law', element: Law},
      {path: 'support', element: Support},
      {path: 'support/faq', element: Faq},
      {path: 'my-ads', element: MyAds},
      {path: 'my-ads/details/:id', element: MyAdDetails},
      {path: 'bookmarks', element: Bookmarks},
      {path: 'edit', element: EditProfile},
    ],
  },
];
